import { createContext, useContext } from "react";

import type { CustomFieldInputType, DocumentFieldSource } from "@/api/db/connection";

export interface EditorField {
	id: number;
	label: string;
	value: string | null | undefined;
	inputType?: CustomFieldInputType;
	patternId?: number | null;
	source?: DocumentFieldSource;
}

export interface EditorPattern {
	id: number;
	name: string;
	label: string;
	minimumItems: 0 | 1;
}

interface EditorFieldsValue {
	fields: Map<number, EditorField>;
	template: boolean;
	readOnly: boolean;
	patterns: Map<number, EditorPattern>;
}

export const EditorFieldsContext = createContext<EditorFieldsValue>({
	fields: new Map(),
	template: false,
	readOnly: false,
	patterns: new Map(),
});

export function useEditorField(fieldId: number) {
	const { fields, template, readOnly } = useContext(EditorFieldsContext);

	return { field: fields.get(fieldId), template, readOnly };
}

export function useEditorReadOnly() {
	return useContext(EditorFieldsContext).readOnly;
}

export function useEditorPattern(patternId: number) {
	return useContext(EditorFieldsContext).patterns.get(patternId);
}
